// extracted by mini-css-extract-plugin
module.exports = {"Wrapper":"ArchiveView_Wrapper__-_XKJ","ArchiveView":"ArchiveView_ArchiveView__16heJ"};